import React, { useState } from "react";
import "./RentCarViewMore.css";

/* Image Imports */
import { Link } from "react-router-dom";
import MarutiSwift from "../../assets/MarutiSwift.png";
import Hyundaii20 from "../../assets/Hyundaii20.png";
import TataAltroz from "../../assets/TataAltroz.png";
import HondaAmaze from "../../assets/HondaAmaze.png";
import ToyotaGlanza from "../../assets/ToyotaGlanza.png";
import HyundaiGrandi10 from "../../assets/HyundaiGrandi10.png";
import MarutiBaleno from "../../assets/MarutiBaleno.png";
import KiaSonet from "../../assets/KiaSonet.png";
import HyundaiVenue from "../../assets/HyundaiVenue.png";
import TataPunch from "../../assets/TataPunch.png";
import MarutiCelerio from "../../assets/MarutiCelerio.png";
import RenaultKwid from "../../assets/RenaultKwid.png";

/* Diesel Cars */

import TataNexon from "../../assets/TataNexon.png";
import HyundaiCreta from "../../assets/HyundaiCreta.png";
import KiaSeltos from "../../assets/KiaSeltos.png";
import MahindraXUV300 from "../../assets/MahindraXUV300.png";
import MahindraScorpio from "../../assets/MahindraScorpio.png";
import ToyotaFortuner from "../../assets/ToyotaFortuner.png";
import MGHector from "../../assets/MGHector.png";
import TataHarrier from "../../assets/TataHarrier.png";
import TataSafari from "../../assets/TataSafari.png";
import MahindraBolero from "../../assets/MahindraBolero.png";
import HyundaiAlcazar from "../../assets/HyundaiAlcazar.png";
import IsuzuDMax from "../../assets/IsuzuDMax.png";

/* CNG Cars */

import MarutiWagonRCNG from "../../assets/MarutiWagonRCNG.png";
import MarutiErtigaCNG from "../../assets/MarutiErtigaCNG.png";
import MarutiDzireCNG from "../../assets/MarutiDzireCNG.png";
import HyundaiAuraCNG from "../../assets/HyundaiAuraCNG.png";
import TataTiagoCNG from "../../assets/TataTiagoCNG.png";
import TataTigorCNG from "../../assets/TataTigorCNG.png";
import MarutiAltoCNG from "../../assets/MarutiAltoCNG.png";
import MarutiSwiftCNG from "../../assets/MarutiSwiftCNG.png";
import HyundaiGrandI10CNG from "../../assets/HyundaiGrandI10CNG.png";
import MarutiBalenoCNG from "../../assets/MarutiBalenoCNG.png";
import ToyotaRumionCNG from "../../assets/ToyotaRumionCNG.png";
import MarutiXL6CNG from "../../assets/MarutiXL6CNG.png";

/* Electric Cars */

import TataNexonEV from "../../assets/TataNexonEV.png";
import TataTiagoEV from "../../assets/TataTiagoEV.png";
import MGZSEV from "../../assets/MGZSEV.png";
import HyundaiKonaEV from "../../assets/HyundaiKonaEV.png";
import MahindraXUV400 from "../../assets/MahindraXUV400.png";
import CitroenEC3 from "../../assets/CitroenEC3.png";
import BYDAtto3 from "../../assets/BYDAtto3.png";
import BYDE6 from "../../assets/BYDE6.png";
import KiaEV6 from "../../assets/KiaEV6.png";
import HyundaiIoniq5 from "../../assets/HyundaiIoniq5.png";
import BMWi4 from "../../assets/BMWi4.png";
import MercedesEQB from "../../assets/MercedesEQB.png";

const carData = [
  /* Petrol Cars */

  {
    id: 1,
    name: "Maruti Swift",
    capacity: "5 Passenger",
    fuel: "Petrol",
    price: 1120,
    image: MarutiSwift,
  },
  {
    id: 2,
    name: "Hyundai i20",
    capacity: "5 Passenger",
    fuel: "Petrol",
    price: 1130,
    image: Hyundaii20,
  },
  {
    id: 3,
    name: "Tata Altroz",
    capacity: "5 Passenger",
    fuel: "Petrol",
    price: 1135,
    image: TataAltroz,
  },
  {
    id: 4,
    name: "Honda Amaze",
    capacity: "5 Passenger",
    fuel: "Petrol",
    price: 1125,
    image: HondaAmaze,
  },
  {
    id: 5,
    name: "Toyota Glanza",
    capacity: "5 Passenger",
    fuel: "Petrol",
    price: 1140,
    image: ToyotaGlanza,
  },
  {
    id: 6,
    name: "Hyundai Grand i10",
    capacity: "5 Passenger",
    fuel: "Petrol",
    price: 1120,
    image: HyundaiGrandi10,
  },
  {
    id: 7,
    name: "Maruti Baleno",
    capacity: "5 Passenger",
    fuel: "Petrol",
    price: 1145,
    image: MarutiBaleno,
  },
  {
    id: 8,
    name: "Kia Sonet",
    capacity: "5 Passenger",
    fuel: "Petrol",
    price: 1150,
    image: KiaSonet,
  },
  {
    id: 9,
    name: "Hyundai Venue",
    capacity: "5 Passenger",
    fuel: "Petrol",
    price: 1155,
    image: HyundaiVenue,
  },
  {
    id: 10,
    name: "Tata Punch",
    capacity: "5 Passenger",
    fuel: "Petrol",
    price: 1110,
    image: TataPunch,
  },
  {
    id: 11,
    name: "Maruti Celerio",
    capacity: "5 Passenger",
    fuel: "Petrol",
    price: 1105,
    image: MarutiCelerio,
  },
  {
    id: 12,
    name: "Renault Kwid",
    capacity: "5 Passenger",
    fuel: "Petrol",
    price: 195,
    image: RenaultKwid,
  },

  /* Diesel Cars */

  {
    id: 13,
    name: "Tata Nexon",
    capacity: "5 Passenger",
    fuel: "Diesel",
    price: 1160,
    image: TataNexon,
  },
  {
    id: 14,
    name: "Hyundai Creta",
    capacity: "5 Passenger",
    fuel: "Diesel",
    price: 1170,
    image: HyundaiCreta,
  },
  {
    id: 15,
    name: "Kia Seltos",
    capacity: "5 Passenger",
    fuel: "Diesel",
    price: 1175,
    image: KiaSeltos,
  },
  {
    id: 16,
    name: "Mahindra XUV300",
    capacity: "5 Passenger",
    fuel: "Diesel",
    price: 1165,
    image: MahindraXUV300,
  },
  {
    id: 17,
    name: "Mahindra Scorpio",
    capacity: "7 Passenger",
    fuel: "Diesel",
    price: 1200,
    image: MahindraScorpio,
  },
  {
    id: 18,
    name: "Toyota Fortuner",
    capacity: "7 Passenger",
    fuel: "Diesel",
    price: 1300,
    image: ToyotaFortuner,
  },
  {
    id: 19,
    name: "MG Hector",
    capacity: "5 Passenger",
    fuel: "Diesel",
    price: 1210,
    image: MGHector,
  },
  {
    id: 20,
    name: "Tata Harrier",
    capacity: "5 Passenger",
    fuel: "Diesel",
    price: 1220,
    image: TataHarrier,
  },
  {
    id: 21,
    name: "Tata Safari",
    capacity: "7 Passenger",
    fuel: "Diesel",
    price: 1230,
    image: TataSafari,
  },
  {
    id: 22,
    name: "Mahindra Bolero",
    capacity: "7 Passenger",
    fuel: "Diesel",
    price:1180,
    image: MahindraBolero,
  },
  {
    id: 23,
    name: "Hyundai Alcazar",
    capacity: "7 Passenger",
    fuel: "Diesel",
    price: 1240,
    image: HyundaiAlcazar,
  },
  {
    id: 24,
    name: "Isuzu D Max",
    capacity: "5 Passenger",
    fuel: "Diesel",
    price: 1260,
    image: IsuzuDMax,
  },

  /* CNG Cars */

  {
    id: 25,
    name: "Maruti WagonR CNG",
    capacity: "5 Passenger",
    fuel: "CNG",
    price: 1110,
    image: MarutiWagonRCNG,
  },
  {
    id: 26,
    name: "Maruti Ertiga CNG",
    capacity: "7 Passenger",
    fuel: "CNG",
    price: 1160,
    image: MarutiErtigaCNG,
  },
  {
    id: 27,
    name: "Maruti Dzire CNG",
    capacity: "5 Passenger",
    fuel: "CNG",
    price:1120,
    image: MarutiDzireCNG,
  },
  {
    id: 28,
    name: "Hyundai Aura CNG",
    capacity: "5 Passenger",
    fuel: "CNG",
    price: 1125,
    image: HyundaiAuraCNG,
  },
  {
    id: 29,
    name: "Tata Tiago CNG",
    capacity: "5 Passenger",
    fuel: "CNG",
    price: 1115,
    image: TataTiagoCNG,
  },
  {
    id: 30,
    name: "Tata Tigor CNG",
    capacity: "5 Passenger",
    fuel: "CNG",
    price: 1120,
    image: TataTigorCNG,
  },
  {
    id: 31,
    name: "Maruti Alto CNG",
    capacity: "4 Passenger",
    fuel: "CNG",
    price: 190,
    image: MarutiAltoCNG,
  },
  {
    id: 32,
    name: "Maruti Swift CNG",
    capacity: "5 Passenger",
    fuel: "CNG",
    price: 1125,
    image: MarutiSwiftCNG,
  },
  {
    id: 33,
    name: "Hyundai Grand i10 CNG",
    capacity: "5 Passenger",
    fuel: "CNG",
    price: 1120,
    image: HyundaiGrandI10CNG,
  },
  {
    id: 34,
    name: "Maruti Baleno CNG",
    capacity: "5 Passenger",
    fuel: "CNG",
    price: 1130,
    image: MarutiBalenoCNG,
  },
  {
    id: 35,
    name: "Toyota Rumion CNG",
    capacity: "7 Passenger",
    fuel: "CNG",
    price: 1150,
    image: ToyotaRumionCNG,
  },
  {
    id: 36,
    name: "Maruti XL6 CNG",
    capacity: "7 Passenger",
    fuel: "CNG",
    price: 1155,
    image: MarutiXL6CNG,
  },

  /* Electric Cars */

  {
    id: 37,
    name: "Tata Nexon EV",
    capacity: "5 Passenger",
    fuel: "Electric",
    price: 1200,
    image: TataNexonEV,
  },
  {
    id: 38,
    name: "Tata Tiago EV",
    capacity: "5 Passenger",
    fuel: "Electric",
    price: 1170,
    image: TataTiagoEV,
  },
  {
    id: 39,
    name: "MG ZS EV",
    capacity: "5 Passenger",
    fuel: "Electric",
    price: 1220,
    image: MGZSEV,
  },
  {
    id: 40,
    name: "Hyundai Kona EV",
    capacity: "5 Passenger",
    fuel: "Electric",
    price: 1230,
    image: HyundaiKonaEV,
  },
  {
    id: 41,
    name: "Mahindra XUV400",
    capacity: "5 Passenger",
    fuel: "Electric",
    price: 1210,
    image: MahindraXUV400,
  },
  {
    id: 42,
    name: "Citroen eC3",
    capacity: "5 Passenger",
    fuel: "Electric",
    price: 1180,
    image: CitroenEC3,
  },
  {
    id: 43,
    name: "BYD Atto 3",
    capacity: "5 Passenger",
    fuel: "Electric",
    price: 1260,
    image: BYDAtto3,
  },
  {
    id: 44,
    name: "BYD e6",
    capacity: "5 Passenger",
    fuel: "Electric",
    price: 1240,
    image: BYDE6,
  },
  {
    id: 45,
    name: "Kia EV6",
    capacity: "5 Passenger",
    fuel: "Electric",
    price: 1300,
    image: KiaEV6,
  },
  {
    id: 46,
    name: "Hyundai Ioniq 5",
    capacity: "5 Passenger",
    fuel: "Electric",
    price: 1310,
    image: HyundaiIoniq5,
  },
  {
    id: 47,
    name: "BMW i4",
    capacity: "5 Passenger",
    fuel: "Electric",
    price: 1400,
    image: BMWi4,
  },
  {
    id: 48,
    name: "Mercedes EQB",
    capacity: "7 Passenger",
    fuel: "Electric",
    price: 1420,
    image: MercedesEQB,
  },
];

const RentCarViewMore=()=> {
  const [filter, setFilter] = useState("Petrol");

  const filteredCars = carData.filter((car) => car.fuel === filter);

  return (
    <div className="rent-car-container">
      <div className="rent-car-buttons">
        <button className="petrol-btn" onClick={() => setFilter("Petrol")}>
          Petrol
        </button>
        <button className="diesel-btn" onClick={() => setFilter("Diesel")}>
          Diesel
        </button>
        <button className="cng-btn" onClick={() => setFilter("CNG")}>
          CNG
        </button>
        <button className="electric-btn" onClick={() => setFilter("Electric")}>
          Electric
        </button>
      </div>

      <div className="rent-car-grid">
        {filteredCars.map((car) => (
          <Link
            to="/type-car-rental-page"
            state={{
              carData: car,
              totalPrice: car.price,
            }}
            className="car-view-more-link"
            onClick={() => {
              sessionStorage.setItem(
                "selectedCar",
                JSON.stringify({
                  carData: car,
                  totalPrice: car.price,
                }),
              );
            }}
          >
            {" "}
            <div className="rent-car-card" key={car.id}>
              <span className="rent-car-fuel-tag">{car.fuel}</span>
              <span className="rent-car-price-tag">{car.price}</span>

              <img src={car.image} alt={car.name} />

              <h3>{car.name}</h3>
              <p>{car.capacity}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default RentCarViewMore;
